import moment from 'moment';
import { Location } from "./Location";
import { Photo } from "./Photo";
import { FrontendEvent } from "./Event";
import { BasePerson as Person } from "./Person";

export class Host {
  constructor(data) {
    var self = this;
    self.type = "Host";
    self.rootvm = data.rootvm;

    self.host_uuid = ko.observable(data.host_uuid);
    self.host_name = ko.observable(data.host_name);
    self.username = ko.observable(data.username);
    self.person_uuid = ko.observable(data.person_uuid);
    self.person = ko.observable();

    self.host_location = ko.observable(new Location(data.location || {}));
    self.host_type = ko.observable(data.host_type);

    self.translated_host_type = ko.computed(function () {
      if (typeof i18nextko != "undefined" && i18nextko.i18n.translator) {
        return i18nextko.i18n.translator.translate(
          "profile.host.edit.loctype." + self.host_type(),
          { defaultValue: self.host_type() }
        );
      } else {
        return self.host_type();
      }
    });

    self.description = ko.observable(data.description);
    self.seats = ko.observable(data.seats);
    self.availability = ko.observable(data.availability);
    self.fee_mode = ko.observable(data.fee_mode);
    self.lodging_number = ko.observable(data.lodging_number);
    self.lodging = ko.observable(data.lodging);
    self.extra_notes = ko.observable(data.extra_notes);

    // Use this to set initial pause
    self.pause_length = ko.observable();

    self.pause_return_date = ko.pureComputed(function () {
      if (self.pause_length() > 0) {
        m = new moment();
        m.add(parseInt(self.pause_length()), "days");
        return m.format("DD/MM/YY");
      }
    });

    self.equipment = ko.observable(data.equipment);
    self.host_loves_extra_text = ko.observable(data.host_loves_extra_text);
    self.provides = ko.observable(data.provides);
    self.age_ranges = ko.observableArray([]);
    if (data.age_ranges) {
      self.age_ranges(data.age_ranges);
    }

    self.host_loves = ko.observableArray([]);

    if (data.host_loves != undefined) {
      self.host_loves(data.host_loves);
    }

    self.phone = ko.observable(data.phone);

    self.liked_genres = ko.observableArray([]);
    if (data.liked_genres) {
      self.liked_genres(data.liked_genres);
    }

    self.show_all_genres = ko.observable(false);

    self.disliked_genres = ko.observableArray([]);

    if (data.disliked_genres) {
      self.disliked_genres(data.disliked_genres);
    }

    self.genre_votes = ko.observable({});

    if (data.genres) {
      self.genre_votes(new GenreVotes(data.genres, data.genre_votes));
    }
    self.inserted = ko.observable(
      data.inserted ? new moment(data.inserted) : undefined
    );

    self.active_since_year = ko.pureComputed(function () {
      if (self.inserted()) {
        return self.inserted().format("YYYY");
      }
    });

    self.deleted = ko.observable(data.deleted);
    self.admin_ranking = ko.observable(data.admin_ranking);
    self.new_admin_ranking = ko.observable(data.admin_ranking);
    self.related_events_count = ko.observable(data.related_events_count || {});
    self.extra_notes = ko.observable(data.admin_extra_notes || "");
    self.new_extra_notes = ko.observable(data.admin_extra_notes) || "";
    self.editing_extra_notes = ko.observable(false);

    self.preferred_currency = ko.observable(data.preferred_currency);
    self.profile_completion = ko.observable(data.profile_completion || 0);

    self.resp_rating = ko.observable();

    self.pretty_age_ranges = ko.computed(function () {
      if (typeof i18nextko != "undefined" && i18nextko.i18n.translator) {
        var translated_strings = [];
        for (var i = 0; i < self.age_ranges().length; i++) {
          translated_strings.push(
            i18nextko.i18n.translator.translate(
              "profile.host.about.agerange." + self.age_ranges()[i]
            )
          );
        }
        return translated_strings.join(", ");
      } else {
        return self.age_ranges().length && self.age_ranges().join(", ");
      }
    });

    self.pretty_liked_genres = ko.pureComputed(function () {
      return self.liked_genres().join(", ");
    });
    self.pretty_disliked_genres = ko.pureComputed(function () {
      return self.disliked_genres().join(", ");
    });

    self.profile_photo_uuid = ko.observable(data.profile_photo_uuid);
    self.profile_photo = ko.observable(new Photo(data.profile_photo));

    self.photos = ko.observableArray([]);

    if (data.photos) {
      self.photos(
        ko.utils.arrayMap(data.photos || [], function (x) {
          return new Photo(x);
        })
      );
    }

    self.current_state = ko.observable(new HostState(data.current_state || {}));
    self.new_state = ko.observable();
    if (data.current_state) {
      self.new_state(data.current_state.state);
    }

    // Location
    self.location_pretty = ko.observable();

    if (data.location) {
      self.location_pretty(data.location.location_name);
    }

    self.location_uuid = ko.observable(data.location_uuid);

    self.location_obj = ko.observable(new Location({}));

    if (data.location) {
      self.location_obj(new Location(data.location));
    }

    // Distance in M
    self.distance_in_m = ko.observable();

    if (data.distance_in_m != null || data.distance_in_m != undefined) {
      self.distance_in_m(data.distance_in_m);
    }

    self.distance_in_km = ko.computed(function () {
      if (self.distance_in_m() != undefined && self.distance_in_m() != null) {
        return Math.round(self.distance_in_m() / 1000) + " km";
      }
    });

    // Favorite
    self.is_favorite = ko.observable(data.is_favorite || false);
    if (
      self.rootvm &&
      self.rootvm.type == "SofaConcertsBaseViewModel" &&
      !self.rootvm.user_logged_in()
    ) {
      self.is_favorite(
        self.rootvm
          .webapp_session()
          .user()
          .guest_fav_host_uuids.indexOf(self.host_uuid()) != -1 || false
      );
    }

    self.upcoming_events = ko.observableArray([]);
    self.past_events = ko.observableArray([]);

    self.feedback = ko.observableArray([]);

    // Rating
    self.rating_average = ko.observable();
    self.rating_count = ko.observable();

    if (data.rating_stats) {
      self.rating_average(data.rating_stats.average);
      self.rating_count(data.rating_stats.count);
    }

    self.rating_star_css = function (star_index) {
      if (self.rating_average()) {
        if (
          self.rating_average() - star_index > 0 &&
          self.rating_average() - star_index < 0.5
        ) {
          return "mdi-star-half";
        } else if (self.rating_average() - star_index <= 0) {
          return "light-grey";
        } else {
          return;
        }
      } else {
        return "light-grey";
      }
    };

    //metrics
    self.request_level = ko.observable();
    self.last_request = ko.observable();
    self.confirm_avg_per_year = ko.observable();

    self.confirm_avg_per_year_css = ko.pureComputed(function () {
      if (self.confirm_avg_per_year() == "high") {
        return "mdi-circle-slice-7";
      } else if (self.confirm_avg_per_year() == "mid") {
        return "mdi-circle-slice-3";
      } else if (self.confirm_avg_per_year() == "low") {
        return "mdi-circle-slice-1";
      } else {
        return "mdi-circle-outline";
      }
    });

    self.request_level_css = ko.pureComputed(function () {
      if (self.request_level() == "high") {
        return "mdi-email-plus";
      } else if (self.request_level() == "mid") {
        return "mdi-email";
      } else if (
        self.request_level() == "low" &&
        self.last_request() != undefined
      ) {
        return "mdi-email-search";
      } else {
        return "mdi-email-outline";
      }
    });

    self.last_request_pretty = ko.pureComputed(function () {
      if (self.last_request()) {
        return self.last_request().format("MMM DD YYYY");
      }
    });

    if (data.request_level) {
      self.request_level(data.request_level);
    }
    if (data.confirm_avg_per_year) {
      self.confirm_avg_per_year(data.confirm_avg_per_year);
    }
    if (data.last_request) {
      self.last_request(new moment(data.last_request));
    }

    // Functions
    self.update_person = function (person_data) {
      person_data.host = self;
      self.person(new Person(person_data));
    };

    if (data.person && typeof data.person != "function") {
      // make sure we don't recreate the artist
      data.person.rootvm = self.rootvm;
      data.person.host = {};
      self.update_person(data.person);
    }

    // Lookups
    self.lookup_public_events = function () {
      self.rootvm.is_busy(true);
      return $.ajax({
        url:
          self.rootvm.web_host +
          "/api/host/events?" +
          self.rootvm.frontend_web_version(),
        cache: true,
        type: "GET",
        data: {
          host_uuid: self.host_uuid(),
        },

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.upcoming_events(
              ko.utils.arrayMap(data.upcoming_events || [], function (x) {
                x.rootvm = self.rootvm;
                return new FrontendEvent(x);
              })
            );

            self.past_events(
              ko.utils.arrayMap(data.past_events || [], function (x) {
                x.rootvm = self.rootvm;
                return new FrontendEvent(x);
              })
            );
          }
        },
        error: function (data) {
          console.log(data);
        },
        complete: function () {
          self.rootvm.is_busy(false);
        },
      });
    };

    self.lookup_feedback = function () {
      self.rootvm.is_busy(true);
      return $.ajax({
        url:
          self.rootvm.web_host +
          "/api/host/feedback?" +
          self.rootvm.frontend_web_version(),
        cache: true,
        type: "GET",
        data: {
          host_uuid: self.host_uuid(),
        },

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.feedback(
              ko.utils.arrayMap(data.feedback || [], function (x) {
                x.rootvm = self.rootvm;
                return new HostFeedback(x);
              })
            );
          }
        },
        error: function (data) {
          console.log(data);
        },
        complete: function () {
          self.rootvm.is_busy(false);
        },
      });
    };

    self.lookup_resp_rating = function () {
      self.rootvm.is_busy(true);
      return $.ajax({
        url:
          self.rootvm.web_host +
          "/api/host/resp-rating?" +
          self.rootvm.frontend_web_version(),
        cache: true,
        type: "GET",
        data: {
          host_uuid: self.host_uuid(),
        },
        contentType: "application/json; charset=utf-8",
        success: function (data) {
          if (data.success) {
            self.resp_rating(data.resp_rating || undefined);
          }
        },
        error: function (data) {
          console.log(data);
        },
        complete: function () {
          self.rootvm.is_busy(false);
        },
      });
    };

    // Save stuff
    //
    self.save_admin_ranking = function () {
      self.rootvm.is_busy(true);
      return $.ajax({
        url: "/api/admin/host-ranking",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          admin_ranking: self.new_admin_ranking(),
          host_uuid: self.host_uuid(),
        }),

        complete: function (data) {
          self.rootvm.is_busy(false);
        },

        success: function (data) {
          if (data.success) {
            self.admin_ranking(data.admin_ranking);
            notyf.success(data.message);
          } else {
            notyf.error(data.message);
          }
        },
      });
    };

    self.cancel_extra_notes = function () {
      self.new_extra_notes(self.extra_notes());
      self.editing_extra_notes(false);
    };

    self.save_extra_notes = function () {
      self.editing_extra_notes(false);

      return $.ajax({
        url: scvm.web_host + "/api/admin/host/extra-notes",
        type: "POST",
        data: ko.toJSON({
          host_uuid: self.host_uuid(),
          extra_notes: self.new_extra_notes(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.extra_notes(data.admin_extra_notes);
            self.new_extra_notes(data.admin_extra_notes);
            self.editing_extra_notes(false);
            notyf.success("Saved!");
          } else {
            notyf.error(data.message);
            self.editing_extra_notes(true);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {},
      });
    };

    self.admin_update_state = function () {
      self.rootvm.is_busy(true);
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/host-update-state",
        type: "POST",
        data: ko.toJSON({
          host_uuid: self.host_uuid(),
          new_state: self.new_state(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            data.current_state.rootvm = self.rootvm;
            self.current_state(new HostState(data.current_state));
            self.new_state(self.current_state().host_state());
            notyf.success("Saved!");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {
          self.rootvm.is_busy(false);
        },
      });
    };

    self.clearing_cache = ko.observable(false);
    self.clear_profile_amazon_cache = async function() {

      self.clearing_cache(true);
      try {
      // Make the POST request to the endpoint
      const response = await fetch('/api/admin/host/clear-amazon-cache', {
        method: 'POST',
        body: JSON.stringify({'host_uuid': self.host_uuid()}),
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
        }
      });

      // Check if the request was successful
      if (!response.ok) {
        throw new Error(`Failed to clear cache:
          ${response.status} ${response.statusText}`);
      }

      // Parse and return the response data
      const data = await response.json();
      console.log('Cache invalidation successful:', data);
      notyf.success('Cache cleared');
      self.clearing_cache(false);
      return data;

      } catch (error) {
      console.error('Error clearing Amazon cache:', error);
          notyf.error("Server error -- failed to clear cache");
      self.clearing_cache(false);
      throw error;
      }
    }

  }
}

export class HostState {
  constructor(data) {
    // Describes an Host State
    var self = this;
    self.type = "HostState";

    self.rootvm = data.rootvm;

    self.host_state = ko.observable(data.state);
    self.inserted = ko.observable(new moment(data.inserted || null));

    self.end_date = ko.observable(new moment(data.end_date || null));

    if (!data.end_date) {
      self.end_date(undefined);
    }

    self.pretty_end_date = ko.pureComputed(function () {
      if (self.end_date()) {
        return self.end_date().format("DD.MM.YYYY");
      }
    });
  }
}

export function GenreVotes(genres, genre_votes) {
  // we're going to make observables for each genre
  var self = this;

  for (var i = 0; i < genres.length; i++) {
    gv = genre_votes[genres[i]["value"]];
    self[genres[i]["value"].toString()] = ko.observable(gv);
  }
}

export class HostFeedback {
  constructor(data) {
    var self = this;
    self.type = "HostFeedback";

    self.artist_uuid = ko.observable(data.artist_uuid);
    self.artist_username = ko.observable(data.artist_username);
    self.feedback_name = ko.observable(data.feedback_name);
    self.icon_path = ko.observable(data.icon_path);
    self.inserted = ko.observable(new moment(data.inserted));
    self.feedback = ko.observable(data.feedback);
    self.event_uuid = ko.observable(data.event_uuid);
    self.event_type = ko.observable(data.event_type);
    self.event_title = ko.observable(data.event_title);

    self.formatted_inserted = function (format) {
      if (self.inserted()) {
        return self.inserted().format(format);
      }
    };
  }
}
